import { Directive, forwardRef, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { FormControlService } from '../form-control.service';

@Directive({
  selector: '[valueAccessor]',
  providers: [
    FormControlService,
    { provide: NG_VALUE_ACCESSOR, useExisting: ValueAccessorImplDirective, multi: true }
  ],
  standalone: true,
})
export class ValueAccessorImplDirective implements ControlValueAccessor {


  readonly #destroy = new Subject<void>()

  constructor(
    @Inject(forwardRef(() => FormControlService))
    private readonly _formControlService: FormControlService
  ) {

  }

  ngOnInit() {

  }

  writeValue(value: any): void {
    this._formControlService.valueSubject.next(value)

  }
  registerOnChange(fn: any): void {

    this._formControlService.valueSubject.pipe(
      takeUntil(this.#destroy)
    )
      .subscribe(fn)

  }
  registerOnTouched(fn: any): void {
    this._formControlService.touchedSubject.pipe(
      takeUntil(this.#destroy)
    )
      .subscribe(fn)
  }

  setDisabledState(isDisabled: boolean): void {

  }


  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
